import React, { useEffect, useState, useCallback } from "react";
import { Layout, Row } from "antd";

import Sidebar from "../Sidebar/index";
import HorizontalDefault from "../Topbar/HorizontalDefault/index";
import HorizontalDark from "../Topbar/HorizontalDark/index";
import InsideHeader from "../Topbar/InsideHeader/index";
import AboveHeader from "../Topbar/AboveHeader/index";
import BelowHeader from "../Topbar/BelowHeader/index";

import Topbar from "../Topbar/index";
import { footerText } from "util/config";
import App from "routes/index";
import { useSelector } from "react-redux";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
} from "../../constants/ThemeSetting";
import NoHeaderNotification from "../Topbar/NoHeaderNotification/index";
import { useRouteMatch } from "react-router-dom";
import paymentLogoBand from "../../assets/images/payment-logo-band.png";
import RequestHandler from "../../util/RequestHandler";
import { getTenantId } from "../../util/profile";
import BannerPromoModal from "../../components/Banner/BannerPromoModal";
import { consumeOpenBannerPromo } from "../../util/BannerPromoSession";

const { Content, Footer } = Layout;

const MainApp = (props) => {
  const { navStyle } = useSelector(({ settings }) => settings);
  const match = useRouteMatch();
  const [tenantInfo, setTenantInfo] = useState({});
  const [bannerPromoOpen, setBannerPromoOpen] = useState(false);
  const closeBannerPromo = useCallback(() => setBannerPromoOpen(false), []);

  const getContainerClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-container-wrap";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-container-wrap";
      default:
        return "";
    }
  };
  const getNavStyles = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />;
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />;
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />;
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />;
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />;
      case NAV_STYLE_FIXED:
        return <Topbar />;
      case NAV_STYLE_DRAWER:
        return <Topbar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Topbar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />;
      default:
        return null;
    }
  };

  useEffect(() => {
    RequestHandler.get("/FirmAuth/GetActiveTenantInfo").then((response) => {
      if (response.success) {
        setTenantInfo(response.data);
      }
      const enabled = Boolean(response?.data?.isShowBannerOnPanel);
      const wantOpen = consumeOpenBannerPromo();
      if (wantOpen && enabled) {
        setBannerPromoOpen(true);
      }
    }).catch(() => {
      consumeOpenBannerPromo();
    });

    const handleOpenPromo = () => setBannerPromoOpen(true);
    window.addEventListener("openBannerPromo", handleOpenPromo);
    return () => window.removeEventListener("openBannerPromo", handleOpenPromo);
  }, []);

  const numberWithSpaces = (value, pattern = "0### ### ## ##") => {
    if (!value) return;
    var i = 0,
      phone = value.toString();
    return pattern.replace(/#/g, (_) => phone[i++]);
  };

  return (
    <>
      <Layout className="gx-app-layout">
        <Sidebar />
        <Layout>
          {getNavStyles(navStyle)}
          <Content
            className={`gx-layout-content ${getContainerClass(navStyle)} `}
          >
            <App match={match} />
            <Footer>
              <Row justify="space-between" align="middle">
                <div className="gx-layout-footer-content">{footerText}</div>
                  <div className="gx-layout-footer-content">
                    <img
                      src={paymentLogoBand}
                      style={{ width: "100%", maxWidth: 450 }}
                    />
                  </div>
                  <div className="gx-layout-footer-content">
                    {numberWithSpaces(tenantInfo.phoneNumber)} <br />
                    {tenantInfo.address}
                  </div>
              </Row>
            </Footer>
          </Content>
        </Layout>
      </Layout>
      <BannerPromoModal
        visible={bannerPromoOpen}
        onCancel={closeBannerPromo}
        tenantId={getTenantId()}
      />
    </>
  );
};
export default MainApp;
